import React, { Suspense, lazy } from 'react';

const LazyComponent = lazy(
  () =>
    import(
      /* webpackChunkName: "catalog-footer-banner" */ './FixedFooterBanner'
    ),
);

const LazyFixedPremiumBar = () => {
  return (
    <div className="hidden md:block">
      <Suspense fallback={null}>
        <LazyComponent />
      </Suspense>
    </div>
  );
};

export default LazyFixedPremiumBar;
